import React from 'react';

import { Banner } from 'components/UI';
import contact from 'data/contact.json';
import { useQueryContext } from 'hooks';

import { Container, Content, Description, Title } from './ContactHero.style';

export function ContactHero() {
	const { images } = useQueryContext();

	return (
		<Container>
			{images.banners.contact && <Banner image={images.banners.contact} />}
			<Content>
				<Title>{contact.title}</Title>
				<Description>{contact.description}</Description>
			</Content>
		</Container>
	);
}
